import { Radio } from 'antd';
import type { InvoicePolicy } from '@salaries/shared';

// The three חשבונית-collection policies + their explanations. Used in both the
// box-settings drawer (inside an antd Form.Item, which injects value/onChange)
// and the onboarding wizard (controlled via props).
const OPTIONS: { value: InvoicePolicy; label: string; desc: string }[] = [
  {
    value: 'none',
    label: 'לא לאסוף חשבוניות',
    desc: 'אנשי הצוות לא נדרשים להוסיף חשבונית לאישור.',
  },
  {
    value: 'optional',
    label: 'לאפשר צירוף חשבונית',
    desc: 'אנשי הצוות יכולים לצרף חשבונית, אך יכולים לאשר את השכר גם בלעדיה.',
  },
  {
    value: 'required',
    label: 'לחייב צירוף חשבונית',
    desc: 'לא ניתן לאשר את השכר ללא צירוף חשבונית (העלאת קובץ או קישור).',
  },
];

export function InvoicePolicyField({
  value,
  onChange,
}: {
  value?: InvoicePolicy;
  onChange?: (v: InvoicePolicy) => void;
}) {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange?.(e.target.value as InvoicePolicy)}
      className="w-full"
    >
      <div className="flex flex-col gap-2">
        {OPTIONS.map((o) => (
          <Radio key={o.value} value={o.value} className="items-start py-1">
            <div className="text-main-text">{o.label}</div>
            <div className="text-small text-secondary-text">{o.desc}</div>
          </Radio>
        ))}
      </div>
    </Radio.Group>
  );
}
